import { IRegistry } from '@cian/mf-registry/shared';
import { useEffect, useRef } from 'react';

import { useApplicationContext } from '../../../../utils/applicationContext';

/**
 * Получает реф на реестр микрофронтов.
 * Многие потребители recommendations-micro-frontend используют старую версию микрофронтов без вызова `layout.writeMicrofrontendsRegistry()`.
 * Подключаемый микрофронт newbuilding-broker-modals-micro-frontend отображается только на главной, которая использует новые микрофронты.
 * Поэтому инициализация реестра на старте приложения обрушит потребителей со старой версией микрофронтов.
 * Когда все потребители recommendations-micro-frontend переедут на новые микрофронты, можно будет забирать реестр из контекста.
 */
export function useMicrofrontendsRegistryRef() {
  const { logger } = useApplicationContext();
  const ref = useRef<IRegistry | undefined>(undefined);

  useEffect(() => {
    import(
      /* webpackMode: "eager" */
      '@cian/mf-registry/browser'
    )
      .then(({ registry }) => {
        ref.current = registry();
      })
      /* istanbul ignore next */
      .catch(error => {
        logger.error(error, {
          domain: 'useMicrofrontendsRegistry',
          message: 'Не удалось получить реестр микрофронтов',
        });
      });
  }, [logger]);

  return ref;
}
